__turbopack_context__.v({
  "badge": "MyAccountLink-module__sBm13W__badge",
  "chevron": "MyAccountLink-module__sBm13W__chevron",
  "children": "MyAccountLink-module__sBm13W__children",
  "container": "MyAccountLink-module__sBm13W__container",
});
